module.exports = __webpack_public_path__ + "img/marker-point-cyan.0dbe65a4.png";